import { useQuery } from "react-query";
import { getCustomerAccounts } from "../../../api/services";

export const useCustomerAccounts = (customerNumber: string) => {
  return useQuery(["customer/accounts", customerNumber], getCustomerAccounts, {
    enabled: !!customerNumber,
  });
};
